import React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  ImageField,
  Toolbar,
  ListButton,
  SaveButton,
  ImageInput,
} from "react-admin";
import { onAddonandVideoTaskLabelCreate } from "../../Service/Validation/AddonandVideoTaskLabelValidation";
import Grid from "@material-ui/core/Grid";
import { RichTextInput } from 'ra-input-rich-text';
import { LabelTypeSelectInput,LabelIdSelectInput,LabelTaskSelectInput } from "../../UI/Input/SelectInput";
const PageTitle = () => {
  return <span>Create Labels</span>;
};

const FormToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton label="Save" redirect="show" submitOnEnter={true} />
    {!props.saving && <ListButton label="Cancel" />}
  </Toolbar>
);
const SanitizedGrid = ({ basePath, ...props }) => {
  return <Grid {...props} />;
};

const AddonandVideoTaskLabelCreate = (props) => {
 
  return (
    <Create title={<PageTitle />} {...props} undoable={false}>
      <SimpleForm toolbar={<FormToolbar />} reValidateMode="onBlur" warnWhenUnsavedChanges validate={onAddonandVideoTaskLabelCreate}>
        <SanitizedGrid container spacing={3} fullWidth>
        <Grid item sm={12} md={4} lg={4}>
        <TextInput label="Label 1" source="label1" fullWidth/>
        </Grid>
        <Grid item sm={12} md={4} lg={4}>
        <TextInput label="Label 2" source="label2" fullWidth/>
        </Grid>
        <Grid item sm={12} md={4} lg={4}>
        <TextInput label="Label 3" source="label3" fullWidth/>
        </Grid>
        <Grid item sm={12} md={4} lg={4}>
        <TextInput label="Label 4" source="label4" fullWidth/>
        </Grid>
        <Grid item sm={12} md={4} lg={4}>
        <TextInput label="Label 5" source="label5" fullWidth/>
        </Grid>
        <Grid item sm={12} md={4} lg={4}>
        <TextInput label="Label 6" source="label6" fullWidth/>
        </Grid>
        <Grid item sm={12} md={4} lg={4}>
        <TextInput label="Label 7" source="label7" fullWidth/>
        </Grid>
        <Grid item sm={12} md={4} lg={4}>
        <TextInput label="Label 8" source="label8" fullWidth/>
        </Grid>
        <Grid item sm={12} md={4} lg={4}>
        <TextInput label="Label 9" source="label9" fullWidth/>
        </Grid>
        <Grid item sm={12} md={4} lg={4}>
        <TextInput label="Label 10" source="label10" fullWidth/>
        </Grid>
        <Grid item sm={12} md={4} lg={4}>
        <TextInput label="Label 11" source="label11" fullWidth/>
        </Grid>
        <Grid item sm={12} md={4} lg={4}>
        <TextInput label="Label 12" source="label12" fullWidth/>
        </Grid>
        <Grid item sm={12} md={4} lg={4}>
        <TextInput label="Label 13" source="label13" fullWidth/>
        </Grid>
        <Grid item sm={12} md={4} lg={4}>
        <TextInput label="Label 14" source="label14" fullWidth/>
        </Grid>
        <Grid item sm={12} md={4} lg={4}> 
        <TextInput label="Label 15" source="label15" fullWidth/>
        </Grid>
        <Grid item sm={12} md={4} lg={4}>
        <LabelTaskSelectInput label="Task Type" source="task_type" fullWidth/>
        </Grid>
        <Grid item sm={12} md={4} lg={4}>
        <LabelTypeSelectInput label="Type" source="type" fullWidth/>
        </Grid>
        <Grid item sm={12} md={4} lg={4}>
        <LabelIdSelectInput label="Label Id" source="label_id" fullWidth/>
        </Grid>
        </SanitizedGrid>
       
      </SimpleForm>
    </Create>
  );
};
export default AddonandVideoTaskLabelCreate;
